<template>
    <i class="ico-svg-chat">
        <svg v-bind="{ width, height }" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 .5C31.045.5 40 8.335 40 18s-8.955 17.5-20 17.5a22.65 22.65 0 01-5.867-.765c-1.3.658-4.098 1.855-8.67 2.763-.593.117-1.187.224-1.783.322-.5.08-.88-.44-.682-.905a24.2 24.2 0 00.61-1.592l.007-.025c.62-1.8 1.125-3.87 1.31-5.798C1.858 26.425 0 22.4 0 18 0 8.335 8.955.5 20 .5zM20 3C10.01 3 2.5 10.02 2.5 18c0 3.67 1.543 7.075 4.195 9.735a2.5 2.5 0 01.718 2.003 27.425 27.425 0 01-.995 5c3.487-.808 5.617-1.743 6.585-2.233a2.5 2.5 0 011.775-.185A20.15 20.15 0 0020 33c9.99 0 17.5-7.017 17.5-15 0-7.98-7.51-15-17.5-15zm1.25 20a1.25 1.25 0 010 2.5h-10a1.25 1.25 0 010-2.5h10zm7.5-6.25a1.25 1.25 0 110 2.5h-17.5a1.25 1.25 0 010-2.5h17.5zm0-6.25a1.25 1.25 0 110 2.5h-17.5a1.25 1.25 0 110-2.5h17.5z" :fill="color" />
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconChat',

    props: {
        width: {
            type: Number,
            default: 40,
        },

        height: {
            type: Number,
            default: 38,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
